<!--
* @Author : ShaJiaJing
* @Date :  2019/5/31
* @Version : 1.0
* @Content : 机器人运行实况
-->
<template>
  <div class="robot-using mb24">
    <h5>
      {{ $t('dashboard.first.title') }}
    </h5>
    <div class="using-wrap">
      <a-row type="flex" :gutter="12">
        <a-col :xl="{span: 17}" :xs="{span: 0}">
          <div class="robot-static">
            <div class="video" ref="video" id="video">
              <div class="poster" v-if="hasOverInit && poster">
                <img class="poster-image" :src="poster" alt="">
                <img class="play" src="~@assets/images/dashboard/play.png" @click="initPlayObj">
              </div>
            </div>
            <a-row class="detail" :gutter="24">
              <a-col :span="8">
                <a-tooltip placement="bottom" :title="currentTask.agentAlias">
                  <p class="ellipsis"><b-icon type="iconjiqiren" />{{ $t('dashboard.first.detail.robot') }}<strong v-text="currentTask.agentAlias"></strong></p>
                </a-tooltip>
              </a-col>
              <a-col :span="8">
                <a-tooltip placement="bottom" :title="currentTask.procName">
                  <p class="ellipsis">
                    <b-icon type="iconliucheng" />{{ $t('dashboard.first.detail.process') }}
                    <strong v-text="currentTask.procName"></strong>
                  </p>
                </a-tooltip>
              </a-col>
              <a-col :span="8">
                <p><b-icon type="iconshalou" />{{ $t('dashboard.first.detail.currentState') }}<strong v-text="currentTask.statusDesc" style="color: #F5222D"></strong></p>
              </a-col>
              <a-col :span="8">
                <p><b-icon type="icondaoqishijian" />{{ $t('dashboard.first.detail.startTime') }}<strong v-text="currentTask.startTime && currentTask.startTime.slice(0, 10)"></strong></p>
              </a-col>
              <a-col :span="8">
                <p><b-icon type="icondaoqishijian" />{{ $t('dashboard.first.detail.endTime') }}<strong v-text="currentTask.endTime && currentTask.endTime.slice(0, 10)"></strong></p>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :xl="{span: 7}" :xs="{span: 24}">
          <div class="recent-task">
            <h6>{{ $t('dashboard.first.recentTask.title') }}</h6>
            <ul class="task-list" v-if="recentTask.length">
              <li :class="`task-item ${item.status}`" :key="index" v-for="(item, index) in recentTask.slice(0, 6)" @click="changeTask(item, false)">
                <p>
                  <span class="time" v-text="item.startTime.slice(0, 10)"></span>
                  <a-tooltip placement="bottom" :title="item.procName">
                    <span class="name ellipsis" v-text="item.procName"></span>
                  </a-tooltip>
                  <span :class="`status status-${item.status}`" v-text="item.statusDesc"></span>
                  <b-icon type="iconrunning" v-if="item.sessionNo"></b-icon>
                </p>
              </li>
            </ul>
            <p v-else class="tip">{{ $t('custom.tip.emptyText') }}</p>
            <p class="more">
              <span @click="$router.push('/task')">
                {{ $t('dashboard.common.details') }}
                <b-icon type="iconyou"></b-icon>
              </span>
            </p>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getRecentJobs } from '@api/dashboard'
import { getVideoPoster } from '@api/play'
export default {
  components: {},
  data () {
    return {
      recentTask: [],
      currentTask: {},
      playWindow: null,
      videoIndex: -1,
      playUi: null,
      continueJumpColor: true,
      position: 0,
      hasOverInit: false,
      poster: ''
    }
  },
  created () {
    this.getRecentJobs()
  },
  mounted () {
    this.playWindow = window.$('#video')
  },
  computed: {
    // currentTask () {
    //   return this.videoIndex >= 0 ? this.recentTask[this.videoIndex] : {}
    // }
  },
  watch: {
    // 'currentTask' (val) {
    //   if (val.sessionNo) {
    //     this.playUi = null
    //     this.initPlayObj()
    //   }
    // }
  },
  methods: {
    getRecentJobs () {
      getRecentJobs().then(res => {
        if (res) {
          this.recentTask = res
          const first = res.filter(row => row.sessionNo)
          this.changeTask(first[0], true)
        }
      })
    },
    changeTask (task, init) {
      this.hasOverInit = init
      if (task.sessionNo) {
        // this.videoIndex = index
        this.currentTask = task
        this.playUi = null
        if (this.hasOverInit) {
          getVideoPoster(task.sessionNo).then(res => {
            this.poster = window.URL.createObjectURL(new Blob([res]))
          })
        } else {
          this.initPlayObj()
        }
      } else {
        return false
      }
    },
    initPlayObj () {
      this.hasOverInit = false
      // 播放器初始化参数
      // 提供回放的webservice服务器地址【必须】
      // const host = '192.168.0.16'
      const host = process.env.VUE_APP_PLAYURL
      // 提供回放的端口【必须】
      const port = 443
      // 提供回放的webservice路径【必须】
      const path = '/play'
      // 播放动作，一般初始化时是 play或者monitoring（监控）【必须】
      const action = 'play'
      // 宽度预留大小，没有该值将没有全屏和窗口效果 【必须】
      const widthSpace = 400
      // 录像编号【必须】
      const sessionNo = this.currentTask.sessionNo
      // var sessionNo = 'a087f70b-8b35-47f2-a222-836f604f8cf5'
      // 录像持续时长【必须】
      const duration = new Date(this.currentTask.endTime) - new Date(this.currentTask.startTime)
      // 录像开始时间
      const timeStart = this.currentTask.startTime

      // 是否按时间范围截断播放进度条 【可选，false不截断】
      const isCutTime = false
      // 窗口能允许的最大宽度 【可选，默认1024】
      // winWidth = $(window).width()
      // 窗口能允许的最大高度 【可选，默认768】
      // winHeight = $(window).height()
      // 是否创建时自动播放 【可选，默认true】
      const isAutoPlay = true
      // 默认是否显示鼠标动作 【可选，默认true】
      const isShowMouse = false
      // 时间显示格式 relative相对，absolute绝对 【可选，默认relative】
      const timeBarMode = 'relative'
      // 是否显示整个播放控制器 【可选，默认true】
      const showCtrlBar = true
      // 是否显示速度控制 【可选，默认true】
      const showChangeSpeed = true
      // 是否显示播放界面内的时间 【可选，默认true】
      const showInnerTime = true
      // 需要显示的设置按钮 cutvideo,timemode,mouseevent,scrshot【可选，默认全部】
      const optBtnConf = 'timemode,scrshot'
      // 初始化播放速度 1或3【可选，默认1】
      const speed = 1
      // 初始化是否全屏播放
      const isFullMax = true
      // if ("yes"  === _original) {
      //   isFullMax = true
      // }
      // 是否1:1
      const isSourceMax = false
      // 宽和高比窗口总大小小多少 【可选，用于调整页面播放窗口大小】
      const widthCut = 0
      const heightCut = 0

      const UI = window.UI
      this.playUi = new UI({
        'container': this.playWindow,
        'host': host,
        'port': port,
        'path': path,
        'action': action,
        'sid': sessionNo,
        'position': 0,
        'duration': duration,
        'startPosition': 0,
        'endPosition': 9999999,
        'isCutTime': isCutTime,
        'winWidth': 'auto',
        'winHeight': 'auto',
        'height': '476',
        'isAutoPlay': isAutoPlay,
        'isShowMouse': isShowMouse,
        'timeBarMode': timeBarMode,
        'showCtrlBar': showCtrlBar,
        'showChangeSpeed': showChangeSpeed,
        'showInnerTime': showInnerTime,
        'optBtnConf': optBtnConf,
        'speed': speed,
        'isFullMax': isFullMax,
        'isSourceMax': isSourceMax,
        'timeStart': timeStart,
        'widthCut': widthCut,
        'heightCut': heightCut,
        'widthSpace': widthSpace,
        'positionChange': this.positionChange,
        'overInit': this.overInit,
        'switchFullScreen': this.switchFullScreen,
        'startCallBack': this.startCallBack,
        'pauseCallBack': this.pauseCallBack,
        'resumeCallBack': this.resumeCallBack,
        'stopCallBack': this.stopCallBack,
        'switchFullScreenBack': this.switchFullScreenBack,
        'setIsAbsTime': this.setIsAbsTime
      })
      // window.onresize = winResize;
    },
    // vnc回掉方法 需要创建对象时注册回调方法，不注册不会生效，不需要使用的方法可以不实现、不注册
    // 播放进度变化回掉 newPosition新的时间偏移量 int
    positionChange (newPosition) {
      this.position = newPosition
      // if (!this.hasOverInit) {
      //   this.playUi._play_pause_btn.click()
      //   // this.playUi._stop_btn.click()
      // }
    },
    // 加载完成，正常播放标志回调
    overInit () {
      // if (this.hasOverInit) return
      // setTimeout(() => {
      //   this.hasOverInit = true
      //   this.playUi._stop_btn.click()
      // }, 200)
    },
    // 窗口大小调整回掉 isFuall是否全屏 宽、高
    switchFullScreen (isFuall, width, height) {
      this.playWindow.width(width)
      this.playWindow.height(height)
    },

    // 开始播放回调 newPosition 开始播放的时间偏移量
    startCallBack (newPosition) {
      this.continueJumpColor = true
    },

    // 暂停回调 newPosition 暂停时的时间偏移量
    pauseCallBack (newPosition) {
      this.continueJumpColor = false
    },

    // 恢复播放回调 newPosition 恢复播放的时间偏移量
    resumeCallBack (newPosition) {
      this.continueJumpColor = true
    },

    // 停止播放回调
    stopCallBack () {
      this.continueJumpColor = false
    },

    // 跳转回调
    jumpCallBack (newPosition) {
      this.continueJumpColor = true
    },

    // 窗口全屏回调，isFull是否全屏，是否1:1
    switchFullScreenBack (isFull, isSource) {

    },

    // 设置时间模式回掉 isAbsTime boolean
    setIsAbsTime (isAbsTime) {
      // 设置是否显示绝对时间
    },
    isContinueJumpColor () {
      return this.continueJumpColor
    }
  },
  beforeDestroy () {
    this.playUi = null
  }
}
</script>

<style lang="less" scoped>
.robot-using{
  background-color: #fff;
  h5{
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    color: #121212;
    padding: 0 24px;
    font-weight: normal;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #d9d9d9;
    .iconfont{
      color: #4977fc;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .using-wrap{
    padding: 6px 12px;
    .recent-task{
      height: 100%;
      padding-bottom: 34px;
      overflow: hidden;
      position: relative;
      h6{
        font-size: 14px;
        color: #333;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .tip{
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        text-align: center;
        padding: 16px;
      }
      .task-list{
        overflow: hidden;
        .task-item{
          position: relative;
          padding-left: 22px;
          cursor: pointer;
          span{
            vertical-align: bottom;
            display: inline-block;
          }
          .time{
            font-size: 12px;
            color: #999;
            margin-right: 14px;
          }
          .name{
            font-size: 14px;
            color: #333;
            letter-spacing: 1px;
            width: 40%;
          }
          .status {
            font-size: 14px;
            margin: 0 12px;
            color: #4977fc;
          }
          .iconfont{
            font-size: 14px;
            color: #4977fc;
          }
          &::before{
            content: '';
            position: absolute;
            width: 14px;
            height: 14px;
            border: 2px solid #4977fc;
            border-radius: 50%;
            top: 4px;
            left: 0;
          }
          & + .task-item{
            margin-top: 38px;
            &::after{
              content: '';
              position: absolute;
              height: 44px;
              width: 2px;
              background-color: #eeeeee;
              left: 6px;
              bottom: 18px;
            }
          }
          &.stopping, &.stopped, &.failed{
            .status{
              color: #FF8831;
            }
            &::before{
              border-color: #FF8831;
            }
          }
          &.running{
            .status{
              color: #67C23A;
            }
            &::before{
              border-color: #67C23A;
            }
          }
        }
      }
      .more{
        text-align: right;
        font-size: 14px;
        color: #4977FC;
        padding: 0 24px 10px;
        position: absolute;
        bottom: 0;
        right: 0;
        span{
          cursor: pointer;
        }
      }
    }
    .robot-static{
      padding: 12px;
      background-color: #eeeeee;
      .detail{
        p{
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          .iconfont{
            font-size: 14px;
            color: #4977FC;
            margin: 0 12px;
            vertical-align: middle;
          }
          strong{
            font-size: 14px;
            color: #666;
            &.status{
              color: #f5222d;
            }
          }
        }
      }
      .video{
        /*height: 476px;*/
        width: 100%;
        padding-bottom: 56%;
        height: 0;
        overflow: hidden;
        position: relative;
        background: url("~@assets/images/dashboard/video_logo2.png") no-repeat center #303030;
        .poster{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          .poster-image{
            width: 100%;
            height: 100%;
          }
          /*&::after{*/
            /*content: '';*/
            /*position: absolute;*/
            /*top: 0;*/
            /*right: 0;*/
            /*left: 0;*/
            /*bottom: 0;*/
            /*background: rgba(0, 0, 0, 0.3);*/
          /*}*/
          .play{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 84px;
            color: #1890ff;
            cursor: pointer;
            text-align: center;
          }
        }
        /deep/ .vnc_isaVncPlay{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          .vnc_canvas_out{
            width: 100% !important;
            height: 100% !important;
            .vnc_zoom_screen_canvas{
              width: 100% !important;
              height: 100% !important;
            }
          }
          .vnc_floatTime{
            position: absolute;
            font-size: 24px;
            color: #3d3d3d;
            width: 105px;
            top: 10px;
            right: 10px;
          }
          .vnc_cover{
            background-color: #fff;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            filter: alpha(opacity=80);
            -moz-opacity: 0.8;
            opacity: 0.8;
            &.vnc_fuzzyCover{
              display: none;
            }
            &.vnc_loadingCover{
              display: none;
              table{
                width: 100%;
                height: 100%;
                .vnc_loading{
                  vertical-align: middle;
                  margin: 0 5px 10px 0;
                  display: inline-block;
                  height: 55px;
                  width: 55px;
                  background: url("~@assets/images/dashboard/loading.gif") no-repeat;
                }
                .vnc_loadMsg{
                  font-size: 24px;
                  color: #7d7d7d;
                }
              }
            }
          }
          .vnc_controlBox{
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            .vnc_control{
              background-color: rgba(0,0,0,.5);
              color: #fff;
              .vnc_topControl {
                height: 11px;
                border-bottom: 1px solid #404040;
                padding: 1px 0px; background: #1F1F1F;
                background: -moz-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                background: -webkit-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                background: -o-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                display: flex;
                justify-content: space-between;
                align-items: center;
                .vnc_progressBox {
                  flex: 1;
                  background: #DEDEDE;
                  cursor: pointer;
                  .vnc_progress {
                    background: #F6A828;
                    height: 11px;
                    .vnc_progress-tip {
                      height: 11px;
                      font-size: 10px;
                      line-height: 10px;
                      background: #FFF;
                      color: #000;
                      position: absolute;
                      top: -12px;
                      display: none;
                    }
                  }
                }
                .vnc_time {
                  padding: 0 12px;
                  text-align: center;
                  font-size: 11px;
                  line-height: 12px;
                }
              }
              .vnc_btmControl{
                background: #1F1F1F;
                background: -moz-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                background: -webkit-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                background: -o-linear-gradient(top, #242424 50%, #1F1F1F 50%, #171717 100%);
                .vnc_mainControl {
                  border-radius: 7px 7px 0 0;
                  display: flex;
                  align-items: center;
                  position: relative;
                  .vnc_btn {
                    width: 34px;
                    height: 30px;
                    padding: 3px 5px;
                    border-right: 1px solid #404040;
                    cursor: pointer;
                    text-align: center;
                  }
                  .vnc_btnPlay {
                    background: url(~@assets/images/dashboard/control.png) no-repeat -6px 0;
                    border-left: 1px solid #404040;
                    &:hover {
                      background: url(~@assets/images/dashboard/control.png) no-repeat -6px -30px;
                    }
                  }
                  .vnc_paused {
                    background: url(~@assets/images/dashboard/control.png) no-repeat -48px 0;
                    border-left: 1px solid #404040;
                    &:hover {
                      background: url(~@assets/images/dashboard/control.png) no-repeat -48px -30px;
                    }
                  }
                  .vnc_btnStop {
                    background: url(~@assets/images/dashboard/control.png) no-repeat -92px 0;
                    &:hover {
                      background: url(~@assets/images/dashboard/control.png) no-repeat -92px -30px;
                    }
                  }
                  .vnc_btnSet {
                    background: url(~@assets/images/dashboard/control.png) no-repeat -134px 0;
                    position: absolute;
                    right: 0;
                    &:hover{
                      background: url(~@assets/images/dashboard/control.png) no-repeat -134px -30px;
                    }
                  }
                  .vnc_text {
                    font-size: 12px;
                    font-weight: bold;
                    line-height: 30px;
                    text-align: center;
                    font-family: verdana;
                    width: 30px;
                    border: none;
                    &.vnc_selected{
                      color: #DEA748;
                    }
                  }
                  .vnc_spdText{
                    border: none;
                    width: 50px;
                    font-size: 12px;
                    line-height: 30px;
                    padding:3px 5px 3px 8px;
                    cursor: default;
                  }
                  .vnc_fullBtn, .vnc_sourceFullBtn{
                    display: none;
                  }
                }
              }
              .vnc_setMenu{
                position: absolute;
                right: 2px;
                background: #666;
                border: #898989 1px solid;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                -o-border-radius: 3px;
                border-radius: 3px;
                display: none;
                .vnc_Menu{
                  padding: 0;
                  li{
                    cursor: pointer;
                    padding: 0 10px;
                    &:hover{
                      background-color: #414141;
                    }
                  }
                  .vnc_ico{
                    display:inline-block;
                    width:20px;
                    height:20px;
                    overflow:hidden;
                    vertical-align:middle;
                    background-image: url(~@assets/images/dashboard/play_ico.png);
                    background-repeat: no-repeat;
                    background-position: 0 0;
                    cursor:pointer;
                    margin-left: 0 !important;
                    margin-right: 5px;
                    &.vnc_ico_screenshot {
                      background-position:-20px -40px;
                    }
                    &.vnc_ico_mouse {
                      background-position:-80px 0;
                    }
                    &.vnc_ico_window {
                      background-position:-60px 0;
                    }
                    &.vnc_ico_cut {
                      background-position:0 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
